import React, { ComponentProps, memo } from 'react'

import { Info, SvgIcon, Warning } from '@surglogs-app/icons'
import { Colors } from '@surglogs-app/ui.theme'
import { isTransElement } from '@surglogs-app/util'

import { FlexBox } from './FlexBox'
import { Icon } from './Icon'
import { Text } from './Text'
type InfoBoxVariant = 'warning' | 'info' | 'danger'
type InfoBoxType = 'default' | 'outline'

const getIconProps = (
  variant: InfoBoxVariant,
): { variant: Colors; icon: SvgIcon } => {
  if (variant === 'warning') {
    return {
      variant: 'orange.100',
      icon: Warning,
    }
  }

  if (variant === 'danger') {
    return {
      variant: 'red.100',
      icon: Warning,
    }
  }

  return {
    variant: 'blue.100',
    icon: Info,
  }
}

const VariantPropsMap = {
  default: {
    info: {
      bgc: 'blue.10',
    },
    warning: {
      bgc: 'orange.10',
    },
    danger: {
      bgc: 'red.10',
    },
  },
  outline: {
    info: {
      bc: 'blue.100',
    },
    warning: {
      bc: 'orange.100',
    },
    danger: {
      bc: 'red.100',
    },
  },
}

interface InfoBoxProps extends ComponentProps<typeof FlexBox> {
  variant?: InfoBoxVariant
  type?: InfoBoxType
}

export const InfoBox = memo(
  ({ children, variant = 'info', type = 'default', ...rest }: InfoBoxProps) => {
    return (
      <FlexBox
        {...{
          gap: 'sm',
          ai: 'center',
          mt: 'sm',
          w: '100%',
          bra: 'sm',
          padding: 'md',
          va: 'middle',
          bd: type === 'outline' ? '1px solid' : undefined,
          ...VariantPropsMap[type][variant],
          ...rest,
        }}>
        <Icon {...getIconProps(variant)} />
        {typeof children === 'string' || isTransElement(children) ? (
          <Text>{children}</Text>
        ) : (
          children
        )}
      </FlexBox>
    )
  },
)
